import { IElement } from 'lib/common/types';

export interface IFiles {
  fileUrl: string;
  fileName: string;
  azureFileName: string;
  originalFileName?: string;
}

export interface CreateFileDto {
  companyId: string;
  sectorsIds: string[];
  files: IFiles[];
  requestId?: string;
}

export interface FileDto {
  id?: string;
  fileName: string;
  fileUrl: string;
  azureFileName: string;
  originalFileName?: string;
  user?: IElement;
  company: IElement;
  sectors: IElement[];
  requestId: string;
}

export interface UpdateFileDto {
  companyId?: string;
  sectorsIds?: string[];
  fileName?: string;
}

export enum ReportType {
  'ASSESSMENT_REPORT' = 'ASSESSMENT-REPORT',
  'CONSULTANT_REPORT' = 'CONSULTANT_REPORT',
}

export interface GetReportUrl {
  azureFileName: string;
  reportType: ReportType;
}
